import { useRef, useState } from "react";
import { Distribution, ClientStock, ClientSearchApiParams } from "../types";
import { Severity } from "../../../type";
import clientStockListApi from "../api/clientStockListApi";

const limit = 10;

/**
 * 一般店用在庫一覧取得
 * @param showAlert アラート
 */
export default function useClientStockList(showAlert: (msg: string, severity?: Severity) => void) {
  const [total, setTotal] = useState(0); // 在庫のレコードの総数
  const [stockList, setStockList] = useState<ClientStock[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isMoreLoading, setIsMoreLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const isFastLoading = useRef(false); // 二重読み込み防止
  const [fireMoreLoadEvent, setFireMoreLoadEvent] = useState(false); // スクロール最下層に達した時、値を変更して発火させるイベント
  const [init, setInit] = useState(false);

  const get = async (searchParams: ClientSearchApiParams) => {
    isFastLoading.current = true;
    setIsLoading(true);
    try {
      const res = await clientStockListApi({...(searchParams ?? {}), ...{offset: 0, limit}});
      setTotal(res.total);
      setStockList(structuredClone(res.stocks));
      setOffset(res.stocks.length);
    } catch (err) {
      console.error(err);
      showAlert('在庫一覧情報の取得に失敗しました。', 'error');
    } finally {
      isFastLoading.current = false;
      setIsLoading(false);
    }
  }

  const getMore = async (searchParams: ClientSearchApiParams) => {
    if (stockList.length >= total || !init) {
      return;
    }

    isFastLoading.current = true;
    setIsMoreLoading(true);
    try {
      const res = await clientStockListApi({
        limit,
        offset,
        ...searchParams
      });
      setTotal(res.total);
      setStockList((prev) => [...prev, ...res.stocks]);
      setOffset((prev) => prev + res.stocks.length);
    } catch (err) {
      console.error(err);
      showAlert('在庫一覧情報の取得に失敗しました。', 'error');
    } finally {
      isFastLoading.current = false;
      setIsMoreLoading(false);
    }
  };

  return [{total, stockList, isLoading, isMoreLoading, isFastLoading, fireMoreLoadEvent}, {setStockList, get, getMore, setFireMoreLoadEvent, setInit}] as const;
}
